import { render, staticRenderFns } from "./Interval.vue?vue&type=template&id=52f0875e"
import script from "./Interval.vue?vue&type=script&lang=js"
export * from "./Interval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports